import styled from 'styled-components';
import { Icon } from '../Icons';
import { IconName } from '../Icons/IconNames';

export function UnifiedLiquidityIndicator({ isMultiProduct = false }: { isMultiProduct?: boolean }) {
  return (
    <StyledUnifiedLiquidityIndicator
      data-testid="unified-liquidity-indicator"
      icon={IconName.Link}
      size={12}
      $isMultiProduct={isMultiProduct}
    />
  );
}

const StyledUnifiedLiquidityIndicator = styled(Icon)<{ $isMultiProduct: boolean }>`
  color: ${({ theme, $isMultiProduct }) => ($isMultiProduct ? theme.colors.green.lighten : theme.colors.blue.lighten)};
  flex-shrink: 0;
  margin-left: ${({ theme }) => theme.spacing2}px;
`;
